//加
function accAdd(arg1, arg2) {
  let r1, r2, m, n;
  try {
    r1 = String(arg1).split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = String(arg2).split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  n = r1 >= r2 ? r1 : r2;
  return Number(((arg1 * m + arg2 * m) / m).toFixed(n));
}
//减
function accSub(arg1, arg2) {
  let r1, r2, m, n;
  try {
    r1 = String(arg1).split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = String(arg2).split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2)); // last modify by deeka //动态控制精度长度
  n = r1 >= r2 ? r1 : r2;
  return Number(((arg1 * m - arg2 * m) / m).toFixed(n));
}
//乘
function accMul(arg1, arg2) {
  let m = 0;
  let n = 0;
  let r1;
  let r2;
  try {
    r1 = String(arg1).split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = String(arg2).split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  n = r1 + r2;
  let s1 = String(arg1);
  let s2 = String(arg2);
  try {
    m += s1.split(".")[1].length;
  } catch (e) {}
  try {
    m += s2.split(".")[1].length;
  } catch (e) {}
  return Number(
    (
      (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
      Math.pow(10, m)
    ).toFixed(n)
  );
}
//除
function accDiv(arg1, arg2) {
  let t1 = 0;
  let t2 = 0;
  let r1;
  let r2;
  try {
    t1 = String(arg1).split(".")[1].length;
  } catch (e) {}
  try {
    t2 = String(arg2).split(".")[1].length;
  } catch (e) {}
  r1 = Number(String(arg1).replace(".", ""));
  r2 = Number(String(arg2).replace(".", ""));
  return (r1 / r2) * Math.pow(10, t2 - t1);
}
export default {
  methods: {
    _add() {
      //加
      let arg = Array.from(arguments);
      return arg.reduce((total, num) => accAdd(total, num));
    },
    _subtract() {
      //减
      let arg = Array.from(arguments);
      return arg.reduce((total, num) => accSub(total, num));
    },
    _multiply() {
      //乘
      let arg = Array.from(arguments);
      return arg.reduce((total, num) => accMul(total, num));
    },
    _divide() {
      //除
      let arg = Array.from(arguments);
      return arg.reduce((total, num) => accDiv(total, num));
    },
    zeros(length) {
      let num = "";
      for (var i = 0; i < length; i++) {
        num += "0";
      }
      return num;
    },
    /**
     * 小数点按位数截取
     * @param {*} number 要截取的值
     * @param {*} numLength  小数点位数
     * @param {*} isZero 是否补零
     * @returns
     */
    fixNumber(number = 0, numLength = 2, isZero = true) {
      let length = number.toString();
      let num = "0.";
      if (length.indexOf(".") == -1) {
        return isZero ? number + "." + this.zeros(numLength) : number;
      }
      length =
        length.split(".")[1].length < numLength
          ? numLength
          : length.split(".")[1].length;
      for (var i = 0; i < length; i++) {
        num += "0";
      }
      num += "1";
      let _value =
        Math.floor((Number(number) + Number(num)) * Math.pow(10, numLength)) /
        Math.pow(10, numLength);
      if (!number) return _value;
      let _float = _value.toString().split(".")[1];
      if (_float.length < numLength) {
        return _value + this.zeros(numLength - _float.length);
      }
      return _value;
    },
    //字符串转number
    _getNumberData(val) {
      const _val = parseFloat(val);
      return isNaN(_val) ? 0 : _val;
    },
  },
};
